<script>
	import { fade, draw } from "svelte/transition";
	// import { tooltip } from "../utils/tooltip";

	export let name;
	export let width = "100%";
	export let height = "100%";
	export let focusable = false;
	export let transform =
		"<style> path {transform: translate(50px, 50px)} </style>";
	let scripts = [
		{
			box: 200,
			name: "manchu",
			svg: `	<style type="text/css">
		.st0 {
			stroke: #000000;
			stroke-miterlimit: 10;
		}
		.st1 {
			fill: #f7f8f9;
		}
	</style>
	<g>
		<path
			class="st0"
			d="M46.17,39.39c9.03,5.2,10.54,13.26,10.66,21.59c0.26,17.45,0.05,34.92,0.15,52.37
		c0.01,2.22-0.71,3.38-2.75,4.22c-11.33,4.68-22.97,6.8-35.04,3.79C6.49,118.2-0.68,106.6,0.66,92.08
		c1.31-14.17,9.92-23.07,23.37-24.02c6.15-0.44,12.33-0.63,18.29,1.32c2.17,0.71,3.08,0.62,3.04-1.98
		c-0.06-4.63,0.03-9.26-0.84-13.82c-1.07-5.63-4.7-8.86-10.17-10.24c-8.21-2.06-16.64-1.86-24.98-2.4
		c-3.94-0.26-4.15-2.08-4.11-5.18c0.04-3,0.02-4.97,4.05-5.22c16.22-0.97,32.42-2.32,48.62-3.53c0.34-0.03,0.68-0.02,1.03-0.05
		c14.42-1.23,17.82-6.41,13.8-20.4c-0.43-1.49-3.67-4.67,0.06-5.12c3.15-0.38,8.01-3.08,10.01,2.76c1.27,3.74,2.33,7.52,2.74,11.43
		c1.34,12.82-3.91,19.37-16.75,21.79C61.7,38.76,54.48,38.11,46.17,39.39z"
		/>
		<path
			class="st1"
			d="M45.33,95.16c0,2.05,0,4.1,0,6.15c0,7.58,0.01,7.65-7.57,9.03c-2.84,0.52-5.77,0.84-8.66,0.83
		c-10.3-0.07-16.41-6.19-16.4-16.18c0.02-10.04,5.57-15.47,16.09-15.73C44.05,78.89,45.33,80.11,45.33,95.16z"
		/>
	</g>`,
		},
		{
			box: 200,
			name: "mandaic",
			svg: `
      <style type="text/css">
		.st0 {
			stroke: #000000;
			stroke-miterlimit: 10;
		}
		.st1 {
			fill: #f7f8f9;
		}
	</style>
  <g>
	<path class="st0" d="M41.31,39.08c-2.03,1.7-2.96,3.58-4.47,5.03c-7.96,7.67-19.41,6.69-27.28,0.53
		C-3.25,34.64-2.31,13.98,11.32,5.07c9.34-6.11,18.98-5.88,28.42-0.6c5.83,3.26,8.46,9.18,10.23,15.34
		C55.04,37.48,60,55.17,65,72.86c0.18,0.64,0.37,1.27,0.58,1.97c0.87-0.44,1-1.27,1.21-2c4.89-17.02,9.73-34.06,14.67-51.08
		c2.38-8.23,6.35-15.33,14.63-19.05c9.8-4.41,22.46-1.49,29.22,6.69c6.73,8.14,7.2,20.85,1.11,29.72
		c-6.09,8.86-16.14,12.58-25.29,9.33c-3.96-1.4-6.99-4.02-9.44-7.38c-0.42-0.57-0.64-1.55-1.51-1.48c-0.99,0.08-0.8,1.13-1,1.79
		c-5.28,17.34-10.52,34.7-15.81,52.04c-0.77,2.52-0.75,5.74-2.66,7.32c-1.65,1.37-4.63,0.35-7.02,0.38
		c-4.55,0.06-4.51,0.01-5.86-4.7c-4.64-16.15-9.3-32.3-13.96-48.44C43.07,45.14,42.24,42.31,41.31,39.08z"/>
	<path class="st1" d="M25.19,13.46c6.34-0.02,11.28,4.98,11.25,11.38c-0.04,6.59-5.02,11.79-11.26,11.75
		c-6.28-0.04-11.48-5.33-11.45-11.65C13.76,18.38,18.64,13.49,25.19,13.46z"/>
	<path class="st1" d="M106.54,13.46c6.26,0.01,11.13,5.07,11.14,11.58c0.01,6.35-5.12,11.62-11.24,11.55
		c-6.27-0.07-11.57-5.47-11.48-11.71C95.05,18.33,100,13.45,106.54,13.46z"/>
</g>`,
		},
		{
			box: 200,
			name: "CAS",
			svg: `<path d="M45.83,14.7c-1.11-0.07-2.22-0.2-3.34-0.21c-13.13-0.01-26.27-0.08-39.4,0.05c-2.5,0.02-3.24-0.75-3.07-3.14
	c0.19-2.63,0.2-5.29,0-7.92C-0.17,0.86,0.66-0.02,3.41,0c15.16,0.13,30.32-0.02,45.48,0.09c12.69,0.09,25.4-0.03,38.05,0.74
	c10.68,0.65,20.6,4.12,29.24,10.89c9.69,7.6,14.9,17.68,16.86,29.53c1.91,11.54,1.47,23.08-2.62,34.12
	c-5.2,14.01-14.43,24.58-28.74,29.82c-15.24,5.59-30.5,5.09-45.16-1.98c-15.74-7.58-24.62-20.6-27.73-37.57
	c-2.09-11.38-1.56-22.59,3.52-33.29c2.96-6.23,6.86-11.66,12.47-15.77c0.49-0.36,1.08-0.59,1.62-0.88
	C46.21,15.38,46.02,15.04,45.83,14.7z M43.95,53.27c0.1,1.32,0.22,2.63,0.28,3.95C45,73.54,55.41,89.93,74.56,93.1
	c14.11,2.33,26.25-1.19,35.09-13.03c6.27-8.4,8.19-18.08,7.97-28.4c-0.2-8.95-2.81-17.01-8.43-23.92
	c-7.86-9.66-18.45-13.53-30.62-13.1c-11.21,0.39-20.71,4.58-27.44,13.94C45.84,35.95,44,44.36,43.95,53.27z"/>`,
		},
		{
			box: 200,
			name: "ol-chiki",
			svg: `<path d="M62.17,20.96c-10.47-7.97-26.08-8.61-34.11-0.35c2.66,3.79,5.39,7.63,8.08,11.49c3.91,5.61,3.76,3.87-0.25,9.08
	c-2.73,3.55-5.46,7.11-8.34,10.53c-0.65,0.78-1.93,1.44-2.93,1.46c-7.4,0.12-14.81,0.03-22.22,0.1c-1.75,0.02-2.46-0.51-2.4-2.34
	c0.11-3.38,0.13-6.77,0-10.15c-0.08-2.03,0.81-2.45,2.61-2.42c5.94,0.08,11.89,0.03,17.83,0.03c0.96,0,1.92,0,3.55,0
	c-1.08-1.62-1.72-2.68-2.46-3.65C17.65,29.64,13.83,24.5,9.8,19.54C8.53,17.96,8.68,17,9.89,15.58c7.4-8.68,16.8-13.6,28.04-15.07
	c17.45-2.28,32.34,3.1,44.52,15.6c8.1,8.32,13.2,18.43,14.95,29.96c3.32,21.9-2.63,40.8-19.35,55.67
	C67.28,111.31,54.3,115.11,40,114.08c-14.75-1.06-25.5-8.42-32.57-21.35c-1.02-1.86-0.65-3.08,0.59-4.61
	C25.4,66.66,42.73,45.17,60.06,23.68C60.75,22.83,61.4,21.96,62.17,20.96z M73.69,31.47c-0.56,0.38-0.83,0.48-1,0.68
	C57.63,50.74,42.56,69.31,27.6,87.97c-0.47,0.59-0.3,2.27,0.22,2.98c2.86,3.91,6.84,6.25,11.54,7.3
	c13.8,3.09,28.85-3.52,36.09-16.03c6.9-11.91,7.66-24.73,4.79-37.89C79.21,39.58,77.11,35.25,73.69,31.47z"/>`,
		},

		{
			box: 200,
			name: "tifinagh",
			svg: `<g>
	<path class="st0" d="M51.07,89.92c-2.53-3.05-4.02-6.13-4.41-9.68c-1.1-10,6.74-16.95,14.79-18.09c6.59-0.93,12.76,0.14,17.66,5.19
		c7.18,7.41,6.46,19.76-1.61,26.91c-6.91,6.13-15.32,8.04-24.22,8.09c-13.9,0.08-26.28-4.13-36.51-13.8
		c-9.76-9.23-14.93-20.62-16.08-34c-1.07-12.48,2.14-23.68,9.58-33.61c7.06-9.41,16.5-15.61,27.86-18.48
		c10.7-2.7,21.46-2.87,31.99,1.27c9.5,3.74,14.46,11.43,13.75,21.58c-0.64,9.28-9.9,16.72-19.82,15.83
		c-7.98-0.72-14.2-4.14-16.81-12.16c-1.6-4.91-0.68-9.66,2.16-14.01c0.39-0.59,1.17-0.98,1.06-1.86
		c-16.19,0.02-33.24,13.89-34.49,34.53C14.44,73.04,32.13,89.37,51.07,89.92z"/>
	<path class="st1" d="M70.78,22.55c0.04,3.48-2.29,6.16-5.4,6.21c-3.25,0.05-5.79-2.74-5.82-6.4c-0.02-2.62,2.72-6.66,4.6-6.77
		C66.98,15.4,70.75,19.38,70.78,22.55z"/>
	<path class="st1" d="M70.79,80.31c-0.01,3.18-3.69,7.09-6.57,6.98c-1.95-0.08-4.68-3.98-4.68-6.69c0-3.55,2.68-6.55,5.81-6.5
		C68.4,74.15,70.8,76.89,70.79,80.31z"/>
</g>`,
		},
		{
			box: 200,
			name: "ranjana",
			svg: `
<g>
	<path class="st0" d="M25.64,41.21c0.66,3.53-0.03,6.54-2.31,9.15c-3.42,3.91-9.12,5.27-13.57,3.17c-4.24-2.01-7.22-7.7-6.51-12.45
		c1.25-8.41,7.66-13.44,16.58-13c4.34,0.21,8.54,1.13,12.59,2.62c2,0.74,2.81,0.64,2.71-1.79c-0.16-3.89-0.14-7.8,0-11.69
		c0.07-2.03-0.5-2.71-2.62-2.68c-9.87,0.11-19.74,0.01-29.61,0.09c-1.77,0.01-2.5-0.32-2.39-2.29c0.18-3.31,0.1-6.64,0.02-9.95
		C0.5,1.05,0.78,0.5,2.29,0.5c27.54,0.05,55.07,0.05,82.61,0c1.6,0,1.91,0.53,1.9,2c-0.04,31.69-0.04,63.39,0.01,95.08
		c0,1.72-0.58,2.05-2.12,2.01c-3.56-0.1-7.14-0.15-10.7,0.01c-2.02,0.09-2.68-0.44-2.65-2.57c0.12-8.38,0-16.76,0.09-25.14
		c0.02-1.62-0.5-2.54-1.84-3.4c-5.72-3.66-11.37-7.45-17.07-11.16c-0.58-0.38-1.19-1.27-1.92-0.78c-0.63,0.43-0.28,1.39-0.28,2.11
		c-0.02,4.98-0.07,9.96,0.02,14.93c0.03,1.57-0.34,2.19-2.04,2.13c-3.73-0.13-7.47-0.12-11.19,0c-1.68,0.05-2.06-0.52-2.04-2.11
		c0.07-8.54-0.01-17.09,0.07-25.64c0.02-1.72-0.53-2.75-2.04-3.54C30.77,43.2,28.54,41.8,25.64,41.21z"/>
	<path class="st1" d="M71.06,53.75c-4.35-2.87-8.68-5.71-12.99-8.59c-2.54-1.69-5.91-2.93-7.33-5.31c-1.49-2.5-0.38-6.14-0.42-9.28
		c-0.06-4.56,0.04-9.11-0.04-13.67c-0.03-1.61,0.29-2.4,2.16-2.36c5.71,0.11,11.43,0.06,17.14,0.02c1.13-0.01,1.85,0.06,1.84,1.54
		c-0.06,12.34-0.04,24.69-0.06,37.03C71.36,53.27,71.24,53.4,71.06,53.75z"/>
</g>`,
		},
		{
			box: 200,
			name: "shuishu",
			svg: `<g>
	<path class="st0" d="M49.39,35.29c-10.29,0-20.58,0.04-30.87-0.04c-1.89-0.02-2.53,0.4-2.5,2.44c0.13,8.3,0.01,16.6,0.09,24.9
		c0.02,1.75-0.5,2.3-2.25,2.23c-3.31-0.13-6.64-0.09-9.96-0.01C2.49,64.83,1.99,64.33,2,62.94C2.03,50.16,2.05,37.38,1.98,24.6
		c-0.01-1.99,1.14-1.79,2.43-1.79c11.78,0.01,23.57-0.05,35.35,0.06c2.43,0.02,3.12-0.72,3.07-3.11c-0.13-6.42-0.03-6.42-6.56-6.42
		c-5.23,0-10.46-0.05-15.68,0.03c-1.7,0.03-2.39-0.49-2.31-2.27c0.12-2.73,0.1-5.48,0.01-8.21c-0.06-1.65,0.42-2.39,2.22-2.38
		c19.25,0.05,38.51,0.04,57.76,0.01c1.6,0,2.22,0.54,2.17,2.17c-0.1,2.82-0.12,5.65,0.01,8.46c0.08,1.83-0.69,2.24-2.35,2.22
		c-6.39-0.07-12.78,0.03-19.17-0.06c-1.75-0.03-2.39,0.51-2.25,2.26c0.13,1.57,0.13,3.16,0,4.73c-0.16,1.94,0.55,2.58,2.53,2.57
		c11.37-0.08,22.74-0.04,34.11-0.04c0.41,0,0.84,0.05,1.24-0.01c1.85-0.28,2.43,0.47,2.41,2.34c-0.09,8.3-0.04,16.6-0.04,24.9
		c0,4.15-0.06,8.3,0.03,12.45c0.03,1.68-0.43,2.39-2.24,2.32c-3.23-0.13-6.48-0.14-9.71,0c-1.85,0.08-2.21-0.7-2.2-2.34
		c0.06-8.3-0.04-16.6,0.08-24.9c0.03-1.91-0.55-2.34-2.38-2.32C70.14,35.33,59.76,35.29,49.39,35.29z"/>
	<path class="st0" d="M84.38,102.64c-12.5,0.04-21.79-6.62-27.22-18.99c-2.36-5.39-3.96-11.05-5.57-16.7
		c-0.39-1.37-0.07-1.89,1.3-2.27c3.43-0.95,6.83-2.03,10.21-3.15c1.51-0.5,2.2-0.13,2.67,1.44c1.76,5.86,3.44,11.75,6.39,17.19
		c4.01,7.39,9.96,10.34,17.91,8.48c3.24-0.76,6.2-2.29,9.05-4.01c0.92-0.55,1.89-1.13,2.59-1.91c1.41-1.56,2.34-1.49,3.5,0.33
		c1.46,2.3,3.18,4.45,4.83,6.62c0.7,0.92,0.92,1.63-0.1,2.52C104.14,97.28,94.53,103.02,84.38,102.64z"/>
	<path class="st0" d="M45,68.33c-0.27,0.55-0.62,1.39-1.08,2.16c-4.63,7.78-11,14.09-17.46,20.3c-5.1,4.91-10.73,9.12-16.87,12.66
		c-1.47,0.85-2.24,0.73-3.11-0.8c-1.68-2.95-3.5-5.83-5.41-8.64c-1.01-1.49-0.66-2.22,0.8-3.07c8.24-4.78,15.38-10.93,21.85-17.89
		c3.12-3.36,6.03-6.85,8.2-10.9c0.7-1.31,1.32-1.35,2.49-0.69c3.09,1.77,6.24,3.44,9.37,5.14C44.36,66.93,45.01,67.18,45,68.33z"/>
	<path class="st0" d="M49.25,55.9c-7.14,0-14.27-0.06-21.4,0.04c-1.89,0.03-2.71-0.36-2.57-2.44c0.18-2.73,0.09-5.47,0.02-8.21
		c-0.03-1.37,0.42-1.89,1.86-1.89c14.77,0.04,29.54,0.04,44.3,0c1.39,0,1.91,0.38,1.86,1.82c-0.09,2.98-0.1,5.98,0,8.96
		c0.06,1.54-0.62,1.75-1.93,1.74C64.02,55.88,56.63,55.9,49.25,55.9z"/>
</g>`,
		},
		{
			box: 200,
			name: "western-cham",
			svg: `	<path
		class="st0"
		d="M49.6,55.3c-1.6,1.81-2.97,3.37-4.86,5.5c0.83,0.47,1.4,0.89,2.04,1.15c11.69,4.86,15.64,20.47,9.64,32.66
	c-2.61,5.3-6.5,9.56-11.33,12.98c-5.81,4.11-12.31,6.74-19,8.94c-0.95,0.31-2.03,0.23-3.44,0.36c-1.43-3.85-2.82-7.59-4.36-11.74
	c1.56-0.69,2.97-1.23,4.31-1.91c5-2.54,10.19-4.77,14.89-7.79c4.43-2.85,7.18-7.15,7.19-12.78c0.01-7.74-6.25-12.72-13.82-10.84
	C29,72.3,27.21,73,24.93,73.74c-1.89-3.37-3.75-6.69-5.91-10.54c1.7-1.1,3.25-2.12,4.81-3.09c6.95-4.34,13.16-9.43,17.04-16.86
	c3.55-6.79,4.07-13.78,0.82-20.79c-3.56-7.69-11.83-10.99-19.41-7.97c-4.32,1.72-7.26,5.89-7.14,10.15
	c0.14,5.13,3.59,8.06,8.69,7.35c1.03-0.14,2.04-0.41,3.49-0.71c2.15,3.34,4.31,6.69,6.73,10.44c-1.41,0.8-2.49,1.64-3.72,2.09
	c-4.76,1.74-9.7,1.88-14.55,0.73C2.97,41.49-3.17,27.47,2.79,15.24C7.4,5.78,18.47,0.08,29.38,0.52
	c20.39,0.82,30.94,19.49,27.55,37.59c-0.32,1.7-0.66,3.4-1.02,5.26c4.54,3.49,9.56,4.73,14.94,3.87
	c7.17-1.15,12.08-8.38,11.32-16.11c-0.57-5.78-3.31-10.29-8.02-13.63c-1.57-1.11-3.19-2.14-5.15-3.44c0.96-3.87,1.91-7.72,2.9-11.74
	c13.31,0,26.26,0,39.49,0c1.06,4.18,0.7,8.26,0.14,13.04c-6.71,0-13.26,0-20.56,0c7.72,13.46,8.69,26.26-2.26,36.96
	C77.24,63.54,63.67,62.35,49.6,55.3z"
	/>`,
		},
		{
			box: 200,
			name: "yi",
			svg: `	<path
		d="M16.73,98.67c1.12,2.1,1.79,4,2.99,5.47c4.74,5.82,14.89,4.7,17.6-2.3c1.53-3.96,1.46-8.56,1.87-12.9
	c0.04-0.41-1.6-1.4-2.47-1.41c-8.91-0.11-17.82-0.07-26.74-0.07c-1.06,0-2.12,0-3.42,0c0-4.96,0-9.68,0-14.85
	c10.9,0,21.71,0,32.44,0c1.16-8.01,1.16-8.01-6.21-8.01c-8.32,0-16.65-0.01-24.97-0.03c-0.29,0-0.58-0.09-1.09-0.17
	c0-4.62,0-9.26,0-14.24C7.7,50.11,8.73,50,9.76,49.99c8.81-0.01,17.63-0.08,26.44,0.04c2.41,0.03,3.32-0.69,3.18-3.17
	c-0.19-3.37-0.05-6.75-0.05-10.65c-3.09,1.91-5.52,3.68-8.17,5c-11.5,5.73-25.85,0.46-29.73-11.13C-3.58,15.15,5.11,3.2,18.59,0.72
	c11.66-2.14,22.24,0.22,30.2,10.57c3.96-3.75,7.74-7.33,11.78-11.16c2.78,3.24,5.52,6.27,8,9.49c0.37,0.48-0.14,2.18-0.76,2.79
	c-3.84,3.77-7.86,7.36-11.73,11.1c-0.67,0.65-1.32,1.76-1.3,2.64c0.19,6.83,0.67,13.65,0.79,20.48c0.04,2.52,0.72,3.48,3.34,3.41
	c5.85-0.16,11.7-0.05,17.74-0.05c0,4.98,0,9.62,0,14.62c-5.79,0-11.44-0.06-17.09,0.04c-1.25,0.02-3.46,0.39-3.57,0.93
	c-0.41,2.05-0.26,4.25,0,6.35c0.04,0.36,1.68,0.71,2.58,0.73c4.99,0.07,9.99,0.04,14.98,0.04c0.96,0,1.93,0,3.09,0
	c0,4.96,0,9.69,0,14.77c-5,0-9.87,0-14.74,0c-6.24,0-6.3,0-6.26,6.13c0.04,6.75-1.42,13.04-5.63,18.44
	c-7.4,9.48-17.5,11.55-28.7,9.82c-8.44-1.3-14.51-6-17.82-13.99c-0.48-1.17-0.79-2.41-1.11-3.64c-0.12-0.45-0.06-0.95-0.1-1.69
	C7.14,101.24,11.92,99.96,16.73,98.67z M16.19,21.75c-0.03,6.27,5.56,10.19,11.24,7.51c2.84-1.34,5.23-3.65,7.81-5.55
	c1.47-1.08,1.36-2.41,0.56-3.87c-1.96-3.61-5.14-5.51-9-6.41C20.89,12.06,16.22,15.75,16.19,21.75z"
	/> ${transform}`,
		},
		{
			box: 200,
			name: "blank",
			svg: ``,
		},
	];
	$: displayScript = scripts.find((e) => e.name === name);
</script>

<svg
	class={$$props.class}
	{focusable}
	{width}
	{height}
	viewBox="0 0 {displayScript.box} {displayScript.box}"
	preserveAspectRatio="xMidYMid meet"
>
	{#key name}
		<g transition:fade>
			{@html displayScript.svg}
		</g>
	{/key}
</svg>

<style></style>
